import { createRouter, createWebHistory } from 'vue-router'
import AggregatorList from '../views/AggregatorList.vue'
import AggregatorDetail from '../views/AggregatorDetail.vue'
import Statistics from '../views/Statistics.vue'
import Login from '../views/Login.vue'
import UserManagement from '../views/UserManagement.vue'
import { auth } from '../utils/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'AggregatorList',
    component: AggregatorList,
    meta: { requiresAuth: true }
  },
  {
    path: '/aggregator/:id',
    name: 'AggregatorDetail',
    component: AggregatorDetail,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics/:id',
    name: 'Statistics',
    component: Statistics,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  
  if (requiresAuth && !auth.isLoggedIn()) {
    // 需要登录但未登录，跳转到登录页
    next('/login')
  } else if (to.path === '/login' && auth.isLoggedIn()) {
    // 已登录但访问登录页，跳转到主页
    next('/')
  } else if (requiresAdmin && auth.getCurrentUser()?.role !== 'admin') {
    // 需要管理员权限但当前用户不是管理员
    next('/')
  } else {
    // 正常访问
    next()
  }
})

export default router
